/**
 * Returns the Indicative Prediction column data.
 *
 * @param {object} data The object containing all the data of the databases to be displayed. e.g.
 * {
 *   aloft_confidence: null
      aloft_fraction_transcripts_affected: null
      aloft_pred: null,
      aloft_prob_dominant: null,
      aloft_prob_recessive: null,
      aloft_prob_tolerant: null,
      bayesdel_addaf_pred: ['D'],
      bayesdel_addaf_rankscore: 0.9446099996566772,
      bayesdel_addaf_score: 0.5058119893074036,
      bayesdel_noaf_pred: ['D'],
      bayesdel_noaf_rankscore: 0.943809986114502,
      bayesdel_noaf_score: 0.48878800868988037,
      blosum: -6,
      ...
    }
 * @param {string} key The key for which we want to seach in the data object.
 * @return {array} formattedPredictions the array with the formatted predictions retrieved from the database, after filtering null entries.
 */

export const getIndicativePrediction = (data, key, group) => {
  if (!data || !Object.keys(data).length || !data?.[key]) return [];

  const predictions = Array.isArray(data[key])
    ? data[key]?.filter((elem) => elem !== null)
    : [data[key]]?.filter((elem) => elem !== null);

  const formattedPredictions = predictions?.map((pred) => {
    if (group && Object.hasOwn(group, pred)) {
      return group[pred];
    }
    return pred;
  });
  return formattedPredictions;
};
